<template lang="pug">
base-dialog(
  :value="value",
  @input="$emit('input', $event)",
  :titulo="titulo",
  :max-width="maxWidth",
  persistent,
  :mostrar-fechar="false",
  texto-confirmar="Clonar",
  :confirmar-desabilitado="!origem || !destino || quantidade === 0",
  @confirmar="$emit('confirmar')"
)
  .mb-2.dialog-texto
    | {{ textoDescricao }}
    br
    | {{ textoObservacao }}

  v-card.pa-3.mt-2(outlined, elevation="0")
    .text-body-2.font-weight-bold.pb-1 Empresa de Origem:
    v-select.preview-field.clonar-select(
      :value="origem",
      @change="$emit('update:origem', $event)",
      :items="opcoesOrigem",
      item-text="label",
      item-value="codigoempresa",
      placeholder="Selecione a empresa de origem",
      outlined,
      dense,
      hide-details,
      single-line
    )
      template(v-slot:item="{ item }")
        span {{ item.codigoempresa }} — {{ item.fantasia || item.razaosocial }}
      template(v-slot:selection="{ item }")
        span {{ item.codigoempresa }} — {{ item.fantasia || item.razaosocial }}

    .text-body-2.font-weight-bold.pb-1.pt-4 Empresa de Destino:
    v-select.preview-field.clonar-select(
      :value="destino",
      @change="$emit('update:destino', $event)",
      :items="opcoesDestino",
      item-text="label",
      item-value="codigoempresa",
      placeholder="Selecione a empresa de destino",
      outlined,
      dense,
      hide-details,
      single-line
    )
      template(v-slot:item="{ item }")
        span {{ item.codigoempresa }} — {{ item.fantasia || item.razaosocial }}
      template(v-slot:selection="{ item }")
        span {{ item.codigoempresa }} — {{ item.fantasia || item.razaosocial }}

  .clonar-info.mt-3(v-if="origem && destino")
    v-icon.mr-1(small, :color="quantidade > 0 ? 'success' : 'grey'") {{ quantidade > 0 ? "mdi-check-circle" : "mdi-information" }}
    span.text-body-2(v-if="quantidade > 0")
      | {{ quantidade }} {{ rotuloItem }}(s) serão adicionados à empresa de destino.
    span.text-body-2(v-else)
      | Nenhum {{ rotuloItem }} novo será adicionado (origem e destino já possuem os mesmos {{ rotuloItem }}s habilitados).
</template>

<script>
import BaseDialog from "./BaseDialog";

export default {
  name: "ClonarDialog",

  components: {
    BaseDialog
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },
    titulo: {
      type: String,
      default: "Clonar"
    },
    origem: {
      type: [String, Number],
      default: null
    },
    destino: {
      type: [String, Number],
      default: null
    },
    opcoesOrigem: {
      type: Array,
      default: () => []
    },
    opcoesDestino: {
      type: Array,
      default: () => []
    },
    quantidade: {
      type: Number,
      default: 0
    },
    rotuloItem: {
      type: String,
      default: "item"
    },
    textoDescricao: {
      type: String,
      default: "Copia os itens habilitados da empresa de origem para a empresa de destino."
    },
    textoObservacao: {
      type: String,
      default: "Itens já desabilitados no destino serão preservados."
    },
    maxWidth: {
      type: [String, Number],
      default: 500
    }
  }
};
</script>

<style scoped>
.dialog-texto {
  font-size: 13px;
  color: #2c3e50;
  line-height: 1.5;
}

.clonar-select {
  font-size: 13px;
}

.clonar-info {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: #f8fbff;
  border: 1px solid #e3f2fd;
  border-radius: 6px;
}

.preview-field {
  border-radius: 6px !important;
  background-color: #fff;
}

.preview-field.v-input--is-focused .v-input__slot {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 1px rgba(25, 118, 210, 0.15);
}

.preview-field .v-input__slot:hover {
  border-color: #b1bac4;
}

.preview-field .v-input__slot,
.preview-field .v-select__selection {
  font-size: 13px !important;
  color: #2c3e50;
  font-weight: 500;
  min-height: 36px !important;
}

.preview-field .v-input__prepend-inner .v-icon,
.preview-field .v-input__append-inner .v-icon {
  color: #57606a;
  font-size: 18px;
}

.preview-field .v-label {
  color: #8a94a3;
  font-size: 13px;
}
</style>
